const cache = /* @__PURE__ */ new Map();
const simpleHash = (str, hashMin = 10) => {
  if (cache.has(str)) {
    return cache.get(str);
  }
  let hash = 0;
  let valids = "";
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const char = str.charCodeAt(i);
    if (char === 46)
      valids += "d0t";
    if (isValidCSSCharCode(char) && len <= hashMin) {
      valids += str[i];
    } else {
      hash = hashChar(hash, str[i]);
    }
  }
  const res = valids + (hash ? Math.abs(hash) : "");
  if (cache.size > 1e4) {
    cache.clear();
  }
  cache.set(str, res);
  return res;
};
const hashChar = (hash, c) => Math.imul(31, hash) + c.charCodeAt(0) | 0;
function isValidCSSCharCode(code) {
  return (
    // A-Z
    code >= 65 && code <= 90 || // a-z
    code >= 97 && code <= 122 || // _
    code === 95 || // -
    code === 45 || // 0-9
    code >= 48 && code <= 57
  );
}
export {
  simpleHash
};
//# sourceMappingURL=index.js.map
